import React, { ReactNode } from "react";
import { InformationCircleIcon } from "@heroicons/react/24/outline";

interface InputFieldProps
  extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
  maxLength?: number;
  required?: boolean;
  helpText?: string;
  register?: any;
  error?: string;
  containerClassName?: string;
  texAreaClass?:string
  /* NEW */
  isTextarea?: boolean;
  row?: number;
}

const InputField: React.FC<InputFieldProps> = ({
  label,
  maxLength,
  required,
  helpText,
  register,
  error,
  containerClassName = "flex flex-col",
  isTextarea = false,
  texAreaClass = "max-h-40 min-h-20",
  row = 3,
  ...props
}) => {
  return (
    <div className={containerClassName}>
      <label className="text-sm font-medium text-gray-700 mb-2 dark:text-gray-300">
        {label} {required && <span className="text-red-700">*</span>}

        {helpText && (
          <span className="relative group ml-1 inline-block">
            <InformationCircleIcon className="w-4 h-4 text-slate-500 cursor-pointer inline" />
            <div className="absolute bottom-full left-1/2 -translate-x-1/2 mb-2 w-64 rounded-md bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 p-3 text-xs text-slate-700 dark:text-slate-200 shadow-lg opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-150 z-50 dark:shadow-gray-700 dark:bg-gray-800">
              {helpText}
            </div>
          </span>
        )}
      </label>

      {isTextarea ? (
<textarea
  rows={row}
  {...register}
  {...(props as any)}
  className={`
    px-3 py-2 border border-gray-300 dark:border-slate-600
    rounded-md bg-white dark:bg-slate-800
    text-sm text-gray-900 dark:text-white
    focus:outline-none focus:ring-1 focus:ring-blue-500
    resize-y
    ${texAreaClass}
  `}
/>

      ) : (
        <input
          {...register}
          {...props}
          className="
            px-3 py-2 border border-gray-300 dark:border-slate-600
            rounded-md bg-white dark:bg-slate-800
            text-sm text-gray-900 dark:text-white
            focus:outline-none focus:ring-1 focus:ring-blue-500
          "
        />
      )}

      {error && (
        <p className="text-xs text-red-500 mt-1">
          {error}
        </p>
      )}
    </div>
  );
};

export default InputField;
